/*
 * SCR-009 Inspire controller — Phase A1. Reads and writes only through NcApp.gateway() (the mock in A1): listLooks (all pages),
 * setLookSaved, getAsset. Cards are cloned from the <template> elements the section ships, so the markup stays the real snippets
 * (editorial look card, collection card, and the heart harvested from the product card).
 *
 * Category chips are a single choice (one always active). "Para ti" = every look; "Tendencias" = every look by like count with the
 * "Tendencia" badge (INFERRED: no trend rule exists); the others match the look tags (#Minimal, #Casual, #Invierno...). The gateway has
 * no style catalogue, so "Explorar por estilo" groups the loaded looks by tag (real counts, UNKNOWN catalogue). Seasonal cards are
 * editorial copy. Badges are INFERRED from likes (>= 1000 Popular, >= 300 Top). Navigation targets are Phase B and only fire events:
 * nc-inspire:open {kind: look|style|season, id}, nc-inspire:browse, nc-inspire:styles, nc-inspire:upload.
 * Per view: loading (skeleton) -> success | empty (ONE CTA) | error (retry) | auth (sign in). Saving a look is optimistic on the heart
 * (loading -> saved with a toast; a rejection rolls back and shows "No se guardó el look"). Category is read from ?category= and written
 * back with replaceState.
 */
(function () {
  var CATS = ['foryou', 'trends', 'minimal', 'office', 'casual', 'night', 'summer', 'winter'];
  var TAGS = { minimal: '#minimal', office: '#oficina', casual: '#casual', night: '#noche', summer: '#verano', winter: '#invierno' };

  function parseCategory(search) {
    var m = /[?&]category=([^&]+)/.exec(search || '');
    var c = m ? decodeURIComponent(m[1]) : '';
    return CATS.indexOf(c) >= 0 ? c : 'foryou';
  }

  // the search string with ?category= set to id (other params, like nc-scenario, are kept)
  function withCategory(search, id) {
    var rest = String(search || '').replace(/^\?/, '').split('&').filter(function (p) { return p && p.split('=')[0] !== 'category'; });
    rest.push('category=' + id);
    return '?' + rest.join('&');
  }

  // "singular|plural" copy: the first form when n is 1
  function plural(text, n) {
    var forms = String(text || '').split('|');
    return forms.length > 1 && Number(n) === 1 ? forms[0] : forms[forms.length > 1 ? 1 : 0];
  }

  // body copy of the error panel by failure kind: [403, 409, 5xx, network]
  function errorBody(kind, bodies, fallback) {
    var list = String(bodies || '').split('|');
    var i = { forbidden: 0, conflict: 1, server: 2, network: 3 }[kind];
    return i === undefined || !list[i] ? fallback : list[i];
  }

  function hasTag(item, tag) {
    return (item.tags || []).some(function (t) { return String(t).toLowerCase() === tag; });
  }

  // filters: { category, author: [] }
  function filterItems(items, filters) {
    var f = filters || {};
    var authors = f.author || [];
    return items.filter(function (it) {
      if (authors.length && authors.indexOf(it.author) < 0) return false;
      var tag = TAGS[f.category];
      return !tag || hasTag(it, tag);
    });
  }

  // "recent" keeps the gateway order; "popular" and the Tendencias category order by likes
  function sortItems(items, sort, category) {
    var list = items.slice();
    if (sort === 'popular' || category === 'trends') list.sort(function (a, b) { return (b.likes || 0) - (a.likes || 0); });
    return list;
  }

  function badgeFor(item, labels, category) {
    labels = labels || [];
    if (category === 'trends') return labels[0] || '';
    if ((item.likes || 0) >= 1000) return labels[2] || '';
    if ((item.likes || 0) >= 300) return labels[1] || '';
    return '';
  }

  function authorFacets(items) {
    var counts = {};
    items.forEach(function (it) { if (it.author) counts[it.author] = (counts[it.author] || 0) + 1; });
    return Object.keys(counts).sort(function (a, b) { return a.localeCompare(b, 'es'); }).map(function (a) { return { value: a, label: a, count: counts[a] }; });
  }

  // style cards: one per tag, most looks first; cover asset = the first look carrying the tag
  function styleGroups(items) {
    var map = {};
    var order = [];
    items.forEach(function (it) {
      (it.tags || []).forEach(function (t) {
        var key = String(t).replace(/^#/, '');
        if (!key) return;
        if (!map[key]) { map[key] = { id: key.toLowerCase(), title: key, count: 0, assetId: it.assetId }; order.push(key); }
        map[key].count += 1;
      });
    });
    return order.map(function (k) { return map[k]; }).sort(function (a, b) { return b.count - a.count; });
  }

  function fill(text, values) {
    return String(text || '').replace(/\{(\w+)\}/g, function (m, k) { return values[k] === undefined ? m : values[k]; });
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { parseCategory: parseCategory, filterItems: filterItems, sortItems: sortItems, badgeFor: badgeFor, authorFacets: authorFacets, styleGroups: styleGroups, fill: fill, withCategory: withCategory, plural: plural, errorBody: errorBody };
  if (typeof customElements === 'undefined' || customElements.get('nc-inspire-screen')) return;

  // a card's link: the route map's page for it, or no link at all (a card without a destination is not interactive; never href="#")
  // nc-nav.js can run after the first cards are built: once the page has loaded, the links of the cards still without one are set
  function relinkCards(root) {
    Array.prototype.forEach.call(root.querySelectorAll('.nc-card__link:not([href])'), function (link) {
      var card = link.closest('[data-id]');
      if (card) setCardLink(link, card.getAttribute('data-entity'), card.getAttribute('data-id'));
    });
  }
  function setCardLink(link, kind, id) {
    var href = '';
    try { href = kind === 'look' && window.NcNav && window.NcNav.url ? window.NcNav.url('look', { id: id }) : ''; } catch (e) { href = ''; }
    if (href) link.setAttribute('href', href); else link.removeAttribute('href');
  }

  class NcInspireScreen extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.gw = window.NcApp.gateway();
      this.pageSize = parseInt(this.getAttribute('data-page-size') || '8', 10);
      this.badges = (this.getAttribute('data-badges') || '').split('|');
      this.category = parseCategory(window.location.search);
      this.syncUrl(true);
      this.sort = 'recent';
      this.authors = [];
      this.items = [];
      this.status = 'idle';
      this.req = 0;
      this.shown = this.pageSize;
      this.live = this.querySelector('[data-insp-status]');
      this.grid = this.querySelector('[data-insp-looks]');
      this.more = this.querySelector('[data-insp-more]');
      this.recs = this.querySelector('[data-insp-recs]');
      this.stylesSection = this.querySelector('[data-insp-styles]');
      this.filtersBtn = this.querySelector('[data-insp-filters-open]');
      this.badgeEl = this.querySelector('[data-insp-badge]');
      this.panelEl = this.querySelector('nc-filter-panel');

      // the shared sidebar has no "inspire" active state yet (proposed change in the report): mark the Inspirate item here
      var accent = this.querySelector('.nc-sidebar__link--accent');
      if (accent) {
        accent.setAttribute('aria-current', 'page');
        if (accent.closest('li')) accent.closest('li').classList.add('nc-sidebar__item--active');
      }

      this.addEventListener('nc-chip:toggle', this.onChip.bind(this));
      this.addEventListener('nc-select:change', this.onSelect.bind(this));
      this.addEventListener('nc-filters:apply', function (e) { self.authors = (e.detail.filters.brand || []).slice(); self.shown = self.pageSize; self.render(); });
      this.addEventListener('nc-card:toggle', this.onToggle.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
      // shim for a shared-component bug (reported, not edited): nc-filter-panel.group() calls draft.available.indexOf on a boolean when it
      // draws the "available" group, which throws on open. Looks have no availability, the group is hidden by CSS; the shim only keeps
      // group() from throwing. Harmless once the component is fixed.
      customElements.whenDefined('nc-filter-panel').then(function () {
        var panel = self.panelEl;
        if (!panel || panel.__ncInspShim) return;
        var group = panel.group;
        panel.group = function (key) {
          if (key !== 'available') return group.apply(this, arguments);
          var saved = this.draft.available;
          this.draft.available = [];
          try { return group.apply(this, arguments); } finally { this.draft.available = saved; }
        };
        panel.__ncInspShim = true;
      });
      this.filtersBtn.addEventListener('click', function () {
        self.panelEl.setFacets({ brand: authorFacets(self.items) });
        self.panelEl.setSelected({ brand: self.authors });
        self.panelEl.open(self.filtersBtn);
      });
      this.more.addEventListener('click', function (e) {
        var btn = e.target.closest('.nc-button');
        if (btn && btn.getAttribute('aria-disabled') !== 'true') self.onMore();
      });

      customElements.whenDefined('nc-chip').then(function () { self.syncChips(); });
      this.load();
    }

    // writes ?category= (replaceState); at start only when the URL carries an invalid value
    syncUrl(onlyIfInvalid) {
      if (onlyIfInvalid && !/[?&]category=/.test(window.location.search)) return;
      try { window.history.replaceState(null, '', window.location.pathname + withCategory(window.location.search, this.category) + window.location.hash); } catch (e) { /* ignore */ }
    }

    // the result of a retry replaces the block that held the focus: move it to the new content instead of letting it fall to body
    restoreFocus() {
      var target = null;
      if (this.status === 'ready') {
        target = this.querySelector('[data-block="empty"]:not([hidden]) .nc-button') || (this.recs.hidden ? null : this.querySelector('[data-insp-heading]'));
      } else if (this.status === 'error') target = this.querySelector('[data-block="error"] .nc-button');
      else if (this.status === 'auth') target = this.querySelector('[data-block="auth"] a, [data-block="auth"] .nc-button');
      else if (this.status === 'loading') target = this.querySelector('[data-block="skeleton"]');
      if (target) target.focus({ preventScroll: true });
    }

    announce(text) { if (this.live) this.live.textContent = text; }

    tpl(name) {
      return this.querySelector('template[data-tpl="' + name + '"]').content.querySelector('article, section').cloneNode(true);
    }

    syncChips() {
      var self = this;
      Array.prototype.forEach.call(this.querySelectorAll('nc-chip'), function (chip) {
        var main = chip.querySelector('.nc-chip__main');
        if (main) main.setAttribute('aria-pressed', chip.getAttribute('data-value') === self.category ? 'true' : 'false');
      });
    }

    onChip(event) {
      var chip = event.target.closest('nc-chip');
      if (!chip) return;
      var id = chip.getAttribute('data-value');
      if (CATS.indexOf(id) < 0) return;
      this.category = id;
      this.syncChips(); // single choice: the active chip cannot be turned off, the others follow
      this.syncUrl(false);
      this.shown = this.pageSize;
      if (this.status === 'ready') this.render();
    }

    load(keepFocus) {
      var self = this;
      var seq = ++this.req;
      this.status = 'loading';
      this.render();
      if (keepFocus) this.restoreFocus();
      var items = [];
      var fetchPage = function (n) {
        return self.gw.listLooks({ page: n }).then(function (page) {
          if (seq !== self.req) return null;
          items = items.concat(page.items);
          if (page.items.length && items.length < page.total && n < 50) return fetchPage(n + 1);
          return page;
        });
      };
      return fetchPage(1).then(function (page) {
        if (!page || seq !== self.req) return;
        self.items = items;
        self.status = 'ready';
        self.shown = self.pageSize;
        self.render();
        if (keepFocus) self.restoreFocus();
      }, function (err) {
        if (seq !== self.req) return;
        self.status = err && err.kind === 'unauthenticated' ? 'auth' : 'error';
        self.error = err;
        self.render();
        if (keepFocus) self.restoreFocus();
      });
    }

    view() {
      return sortItems(filterItems(this.items, { category: this.category, author: this.authors }), this.sort, this.category);
    }

    show(name) {
      ['skeleton', 'empty', 'error', 'auth'].forEach(function (n) {
        var el = this.querySelector('[data-block="' + n + '"]');
        if (el) el.hidden = n !== name;
      }, this);
      var content = name === '';
      this.recs.hidden = !content;
      if (!content) this.stylesSection.hidden = true;
    }

    render() {
      this.grid.textContent = '';
      this.grid.setAttribute('aria-busy', this.status === 'loading' ? 'true' : 'false');
      this.more.hidden = true;
      this.querySelector('[data-block="empty-filtered"]').hidden = true;
      this.updateBadge();
      if (this.status === 'loading' || this.status === 'idle') { this.show('skeleton'); return; }
      if (this.status === 'auth') { this.show('auth'); this.announce(this.error && this.error.message || ''); return; }
      if (this.status === 'error') {
        var body = this.querySelector('[data-block="error"] .nc-state-panel__body');
        if (!this.defaultErrorBody && body) this.defaultErrorBody = body.textContent;
        if (body) body.textContent = errorBody(this.error && this.error.kind, this.getAttribute('data-error-bodies'), this.defaultErrorBody);
        this.show('error'); this.announce(this.error && this.error.message || ''); return;
      }
      if (!this.items.length) { this.show('empty'); this.announce(this.querySelector('[data-block="empty"] .nc-state-panel__title').textContent); return; }
      this.show('');
      var groups = styleGroups(this.items);
      this.renderStyles(groups);
      var list = this.view();
      if (!list.length) {
        this.querySelector('[data-block="empty-filtered"]').hidden = false;
        this.announce(this.querySelector('[data-block="empty-filtered"] .nc-state-panel__title').textContent);
        return;
      }
      this.appendCards(list.slice(0, this.shown), 0);
      this.setMore(list.length);
      this.announce(fill(this.getAttribute('data-msg-shown'), { n: Math.min(this.shown, list.length), t: list.length }));
    }

    updateBadge() {
      var n = this.authors.length;
      this.badgeEl.hidden = !n;
      this.badgeEl.textContent = n ? String(n) : '';
      var base = this.getAttribute('data-label-filters') || '';
      this.filtersBtn.setAttribute('aria-label', n ? fill(plural(this.getAttribute('data-label-filters-n'), n), { n: n }) : base);
    }

    setMore(total) {
      var all = this.shown >= total;
      var btn = this.more.querySelector('.nc-button');
      var end = this.more.querySelector('[data-more-end]');
      this.more.hidden = false;
      if (btn) btn.hidden = all;
      if (end) end.hidden = !all || total <= this.pageSize;
      if (all && total <= this.pageSize) this.more.hidden = true;
    }

    // asset ids are placeholders in A1 (src null): the neutral media slot stays; a real src fills it without layout change
    media(card, assetId, alt, eager) {
      var slot = card.querySelector('.nc-card__media');
      if (!slot || !assetId || !this.gw.getAsset) return;
      this.gw.getAsset(assetId).then(function (a) {
        if (!a || !a.src || slot.querySelector('img')) return;
        var img = document.createElement('img');
        img.src = a.src;
        img.alt = alt || '';
        img.width = a.width || 400;
        img.height = a.height || 300;
        img.loading = eager ? 'eager' : 'lazy';
        slot.insertBefore(img, slot.firstChild);
      }, function () {});
    }

    buildLook(item, index) {
      var card = this.tpl('look');
      var sub = card.querySelector('.nc-look-card__action span');
      if (sub && item.author) sub.textContent = item.author;
      var badge = badgeFor(item, this.badges, this.category);
      if (badge) {
        var b = document.createElement('span');
        b.className = 'nc-look-card__badge';
        b.textContent = badge;
        card.insertBefore(b, card.querySelector('.nc-look-card__caption'));
      }
      var src = this.querySelector('template[data-tpl="save"]').content.querySelector('.nc-toggle');
      var btn = src.cloneNode(true);
      btn.setAttribute('data-id', item.id);
      btn.setAttribute('aria-pressed', item.saved ? 'true' : 'false');
      btn.setAttribute('data-initial-pressed', item.saved ? 'true' : 'false');
      btn.setAttribute('aria-label', (this.getAttribute('data-label-save') || '') + ': ' + item.title);
      card.appendChild(btn);
      card.setAttribute('data-id', item.id);
      card.setAttribute('data-entity', 'look');
      card.querySelector('.nc-card__link').textContent = item.title;
      setCardLink(card.querySelector('.nc-card__link'), 'look', item.id);
      this.media(card, item.assetId, item.title, index < 4);
      return card;
    }

    appendCards(items, offset) {
      var self = this;
      items.forEach(function (item, i) { self.grid.appendChild(self.buildLook(item, offset + i)); });
      if (document.readyState === 'complete') relinkCards(this); else window.addEventListener('load', function () { relinkCards(self); }, { once: true });
    }

    renderStyles(groups) {
      var self = this;
      var host = this.querySelector('[data-insp-style-grid]');
      host.textContent = '';
      this.stylesSection.hidden = !groups.length;
      groups.slice(0, 6).forEach(function (g) {
        var card = self.tpl('style');
        card.querySelector('.nc-collection-card__count').textContent = fill(plural(self.getAttribute('data-style-count'), g.count), { n: g.count });
        card.setAttribute('data-id', g.id);
        card.setAttribute('data-entity', 'style');
        card.querySelector('.nc-card__link').textContent = g.title;
        setCardLink(card.querySelector('.nc-card__link'), 'style', g.id);
        self.media(card, g.assetId, g.title, false);
        var li = document.createElement('div');
        li.className = 'nc-inspire__style';
        li.appendChild(card);
        host.appendChild(li);
      });
    }

    onMore() {
      var list = this.view();
      var from = this.shown;
      this.shown = Math.min(list.length, this.shown + this.pageSize);
      this.appendCards(list.slice(from, this.shown), from);
      this.setMore(list.length);
      var first = this.grid.children[from];
      var link = first && first.querySelector('.nc-card__link');
      if (link) link.focus({ preventScroll: false });
      this.announce(fill(this.getAttribute('data-msg-shown'), { n: this.shown, t: list.length }));
    }

    onSelect(event) {
      var input = event.target.querySelector && event.target.querySelector('input[type="hidden"]');
      if (!input || input.name !== 'sort') return;
      this.sort = String(event.detail && event.detail.value);
      this.shown = this.pageSize;
      if (this.status === 'ready') this.render();
    }

    fire(name, detail) { this.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} })); }

    onClick(event) {
      if (event.target.closest('[data-block="error"] .nc-button')) { this.load(true); return; }
      if (event.target.closest('[data-block="empty"] .nc-button')) { this.fire('nc-inspire:upload'); return; }
      if (event.target.closest('[data-block="empty-filtered"] .nc-button')) {
        this.authors = [];
        this.category = 'foryou';
        this.syncChips();
        this.syncUrl(false);
        this.shown = this.pageSize;
        this.render();
        var heading = this.querySelector('[data-insp-heading]');
        if (heading) heading.focus({ preventScroll: true });
        return;
      }
      var ev = event.target.closest('[data-insp-event]');
      if (ev) {
        event.preventDefault();
        var kind = ev.getAttribute('data-insp-event');
        if (kind === 'browse') this.fire('nc-inspire:browse');
        else if (kind === 'styles') this.fire('nc-inspire:styles');
        else this.fire('nc-inspire:open', { kind: 'season', id: ev.getAttribute('data-id') });
        return;
      }
    }

    // the heart saves / unsaves a look
    onToggle(event) {
      var d = event.detail;
      if (d.kind !== 'favorite') return;
      var self = this;
      var btn = event.target.closest('.nc-toggle');
      var card = btn.closest('[data-entity="look"]');
      if (!card) return;
      var id = card.getAttribute('data-id');
      window.NcCard.setState(btn, 'loading');
      this.gw.setLookSaved({ lookId: id, value: d.pressed }).then(function () {
        window.NcCard.setState(btn, 'default');
        var it = self.items.filter(function (x) { return x.id === id; })[0];
        if (it) it.saved = d.pressed;
        window.NcToast.show({ tone: 'success', message: self.getAttribute(d.pressed ? 'data-msg-saved' : 'data-msg-unsaved') || '' });
      }, function (err) {
        var msg = self.getAttribute('data-msg-save-error') || '';
        window.NcCard.setState(btn, 'error', msg);
        window.NcToast.show({ tone: 'error', message: msg, detail: err && err.message });
      });
    }
  }

  customElements.define('nc-inspire-screen', NcInspireScreen);
})();
